// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TDVnePlDmMiqj2gcsrO1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 500px;
  padding: 24px;
}
.TDVnePlDmMiqj2gcsrO1 .JWHdWkbqPW0LwSbMa8cr {
  margin-bottom: 20px;
}
.TDVnePlDmMiqj2gcsrO1 .cCeKsdtg7CEBZfBSMDeD {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.TDVnePlDmMiqj2gcsrO1 .orOFC80nmd6aVw5InhIO h4 {
  margin-bottom: 12px;
  color: #fff;
  font-size: 16px;
}
.TDVnePlDmMiqj2gcsrO1 .hg2cLrysUNZYF3mSO7lQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  margin-bottom: 8px;
}
.TDVnePlDmMiqj2gcsrO1 .hg2cLrysUNZYF3mSO7lQ:hover {
  background: rgba(255, 255, 255, 0.1);
}
.TDVnePlDmMiqj2gcsrO1 .QSD43Z6BNYvg9Tfg7pCf {
  font-family: monospace;
  color: #fff;
  font-size: 14px;
  word-break: break-all;
}
.TDVnePlDmMiqj2gcsrO1 .YFcEeW_zi6yw9slDpuuD {
  background: transparent;
  border: 1px solid #ff4444;
  color: #ff4444;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}
.TDVnePlDmMiqj2gcsrO1 .YFcEeW_zi6yw9slDpuuD:hover {
  background: rgba(255, 68, 68, 0.1);
}
.TDVnePlDmMiqj2gcsrO1 .YFcEeW_zi6yw9slDpuuD:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.TDVnePlDmMiqj2gcsrO1 .XsJAkPoRxKgTEDiDRiWQ {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Components/RaffleManagerModal/RaffleManagerModal.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACE,mBAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAN;AAIM;EACE,mBAAA;EACA,WAAA;EACA,eAAA;AAFR;AAMI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;AAJN;AAMM;EACE,oCAAA;AAJR;AAQI;EACE,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AANN;AASI;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAPN;AASM;EACE,kCAAA;AAPR;AAUM;EACE,YAAA;EACA,mBAAA;AARR;AAYI;EACE,+BAAA;EACA,kBAAA;AAVN","sourcesContent":[".managerModalContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    min-width: 500px;\r\n    padding: 24px;\r\n    \r\n    .addManagerSection {\r\n      margin-bottom: 20px;\r\n    }\r\n  \r\n    .managersListSection {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 24px;\r\n    }\r\n  \r\n    .managerSection {\r\n      h4 {\r\n        margin-bottom: 12px;\r\n        color: #fff;\r\n        font-size: 16px;\r\n      }\r\n    }\r\n  \r\n    .managerRow {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 8px;\r\n      background: rgba(255, 255, 255, 0.05);\r\n      border-radius: 4px;\r\n      margin-bottom: 8px;\r\n  \r\n      &:hover {\r\n        background: rgba(255, 255, 255, 0.1);\r\n      }\r\n    }\r\n  \r\n    .managerAddress {\r\n      font-family: monospace;\r\n      color: #fff;\r\n      font-size: 14px;\r\n      word-break: break-all;\r\n    }\r\n  \r\n    .removeButton {\r\n      background: transparent;\r\n      border: 1px solid #ff4444;\r\n      color: #ff4444;\r\n      padding: 4px 12px;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      transition: all 0.2s;\r\n  \r\n      &:hover {\r\n        background: rgba(255, 68, 68, 0.1);\r\n      }\r\n  \r\n      &:disabled {\r\n        opacity: 0.5;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n  \r\n    .noManagers {\r\n      color: rgba(255, 255, 255, 0.5);\r\n      font-style: italic;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"managerModalContent": `TDVnePlDmMiqj2gcsrO1`,
	"addManagerSection": `JWHdWkbqPW0LwSbMa8cr`,
	"managersListSection": `cCeKsdtg7CEBZfBSMDeD`,
	"managerSection": `orOFC80nmd6aVw5InhIO`,
	"managerRow": `hg2cLrysUNZYF3mSO7lQ`,
	"managerAddress": `QSD43Z6BNYvg9Tfg7pCf`,
	"removeButton": `YFcEeW_zi6yw9slDpuuD`,
	"noManagers": `XsJAkPoRxKgTEDiDRiWQ`
};
export default ___CSS_LOADER_EXPORT___;
